



























import 'reflect-metadata'
import { Vue, Component } from 'vue-property-decorator'
import {
    DEFAULT_NETWORK_ID,
    DEFAULT_NETWORK_NAME,
} from '@/store/modules/network/network'

@Component({})
export default class TestnetAlert extends Vue {
    get networkID(): number {
        return DEFAULT_NETWORK_ID
    }

    get networkName(): string {
        return DEFAULT_NETWORK_NAME
    }

    get statsURL() {
        return 'https://stats.avax.network/'
    }
}
